import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import {withNamespaces} from 'react-i18next';
import './InstanceLoading.css';
import Paper from '@material-ui/core/Paper';
import logo from '../Sidebar/logo.png';
import InstanceError from './InstanceError';


const InstanceLoading = (props) => {
    const {t} = props;
    if (!props.instance) {
        return (
            <div className="canvas">
                <div className="loadingWrapper">
                    <Paper className="paper">
                        <img src={logo} alt="PowerGym" className="logoLoading"/>
                        <p>{t("Loading Instance")}...</p>
                        <CircularProgress/>
                    </Paper>
                </div>
            </div>
        );
    }

    if (!props.instance.data) {
        return <InstanceError error={props.instance.error || {}} />;
    }
};

export default withNamespaces()(InstanceLoading);
